import { InjectionToken } from '@angular/core';
import { environment } from '../../environments/environment';

/**
 * Whether conduct pages require a 학교종이 session (`environment.requireLogin`). On in production;
 * off in development and staging, where the pages open without a session.
 */
export const REQUIRE_LOGIN = new InjectionToken<boolean>('REQUIRE_LOGIN', {
  factory: () => environment.requireLogin,
});
